import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ResourceCenterComponent } from './resource-center.component';
import { SharedModule } from '../shared.module';
import { TableModule } from '@zipari/design-system';
import { FooterModule } from '../footer/footer.module';

@NgModule({
  declarations: [ResourceCenterComponent],
  imports: [CommonModule, SharedModule, TableModule, FooterModule],
  exports: [ResourceCenterComponent],
})
export class ResourceCenterModule {}
